import { Button } from "react-bootstrap";
import { useState } from "react";
import PopupWrapper from "../../components/PopupWrapper";
import AddReportListForm from "../../components/AdminReportListComp/AddReportListForm";
import CommonGrid from "../../components/CommonGrid";
import { SpinnerBlock } from "../../Utils/CustomComponent";

const AdminReportList = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [refreshTable, setRefreshTable] = useState(false);
  const [tableData, setTableData] = useState([]);
  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <div className="d-flex justify-content-between mt-4 bg-white pb-4">
          <h2 className="bg-light p-4">Report List</h2>
          <Button
            className="text-white me-5 mt-5"
            onClick={() => {
              setShowPopup(true);
            }}
          >
            Add Report
          </Button>
          {showPopup && (
            <PopupWrapper
              title={
                <h2 className="p-4 font-weight-bold text-dark">
                  Add a Report
                </h2>
              }
              Component={
                <AddReportListForm
                  close={() => setShowPopup(false)}
                  refreshTable={() => setRefreshTable(!refreshTable)}
                />
              }
              toShow={showPopup}
              closeEventHandler={() => {
                setShowPopup(false);
              }}
            />
          )}
        </div>
        <div className="p-4 col-sm-12">
          {tableData ? (
            <CommonGrid
              className={"loans_in_workout bg-white col-sm-12"}
              title={"Report List"}
              gridColumns={gridColumns_adminMenuItems}
              columnData={tableData}
            />
          ) : (
            <SpinnerBlock />
          )}
        </div>
      </section>
    </div>
  );
};

export default AdminReportList;
const gridColumns_adminMenuItems = [
  {
    field: "Report Name",
    title: "Report Name",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Report Link",
    title: "Report Link",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Report Description",
    title: "Report Description",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Report Order",
    title: "Report Order",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Is Active",
    title: "Is Active",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Created",
    title: "Created",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Created by",
    title: "Created by",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Updated",
    title: "Updated",
    style: { width: "10%", wordBreak: "break-all" },
  },
  {
    field: "Updated By",
    title: "Updated By",
    style: { width: "10%", wordBreak: "break-all" },
  },

];
